export default function checkDuration(length, date) {
  if (length > date?.end_at?.timestamp - date?.start_at?.timestamp) {
    return true;
  } else {
    return false;
  }
}
